/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from 'react'
import { css, useTheme } from '@emotion/react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import { Context } from "../../../context/StaffTeamContext";
//import { get_staff } from '../../../redux/actions/staff/get_staff';
import Modal from '../Modal/index';
import { put_staff_cards } from '../../../redux/actions/staff_cards/put_staff_cards';
import { post_staff_cards } from '../../../redux/actions/staff_cards/post_staff_cards';
import { delete_staff_cards } from '../../../redux/actions/staff_cards/delete_staff_cards';


const AboutUsPreview: React.FC = () => {
  const dispatch = useDispatch()
  const theme = useTheme() as ThemeUI
  const navigate = useNavigate();
  const { formData } = useContext(Context)
  const token = useSelector((state: any) => state.login.access)
  let { id } = useParams();
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false)


  const handleChange = (token: any, formData: any) => {
    if (id) {
      console.log(id)
      dispatch(put_staff_cards({ id, token, data: formData, navigate }))
    } else {
      delete formData.id
      dispatch(post_staff_cards({ token, data: formData, navigate }))
    }
  }

  const handleDelete = () => {
    dispatch(delete_staff_cards({ id, token, data: formData, navigate }))
    //dispatch(get_banners({ lang: null, token }))
  }


  const successAction = () => {
    handleChange(token, formData)
    //dispatch(get_banners({ lang: null, token }))
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }


  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType='p' weight='bold'>Vista Previa</Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>
        {
            formData.image &&
            (
              <img
                src={formData.image}
                alt='placeholder'
                css={styles.previewImage}
              />
            )
          }
          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.name}
          </Text>
          <div css={styles.previewDescription(theme)}>
            <Text textType='sm' weight='light'>
              {formData.job_position}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.lang}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => {
        setShowModal(true)
      }} disabled={!formData.job_position || !formData.lang || !formData.name}>
        {!id ? 'Publicar' : 'Guardar'} Personal
      </Button>

      {
        id ?
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de modificar este personal?'}
              text={' '}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal} />
          ) :
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de publicar este personal?'}
              text={''}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal}
            />
          )
      }


      {id && (
        <>
          <Button onClick={() => {
            setShowModalDelete(true)
          }}>
            Eliminar personal
          </Button>
          <Modal
            show={showModalDelete}
            title={'¿Esta seguro de eliminar este personal?'}
            text={' '}
            onClickSuccess={handleDelete}
            onClickClose={closeModalDelete}
            btnSuccess={'Si'}
            btnWarning={"No"}
            onClickWarning={closeModalDelete}
          />
        </>
      )}
    </ContentSection>
  )
}


export default AboutUsPreview;
